import React, {useEffect, useRef, useState} from "react";
import ApiService from "../../services/ApiService";
import {notification, Spin} from "antd";
import ContactMainCard from "./ContactMainCard";
import {MobTabs} from "../components/MobTabs";
import SwipeableViews from 'react-swipeable-views';
import {t} from "@lingui/core/macro"
import ContactTabMain from "./ContactTabMain";
import {MobEditButton} from "../components/MobEditButton";
import ModalEdit from "../../views/app-views/contact/ModalEdit";
import {MobHeader} from "../components/MobHeader";
import ContactTabSecondary from "./ContactTabSecondary";
import {checkForfait, checkPermissions} from "../../components/permissions/functions";
import IntlMessage from "../../components/util-components/IntlMessage";
import {useLocation} from "react-router-dom";
import {MobSpin} from "../components/MobSpin";
import ContactTabRelations from "./ContactTabRelations";
import ContactTabInteractions from "./ContactTabInteractions";
import ChlihoutForm from '../../views/app-views/contact/chlihout';
import { ENV } from '../../configs/AppConfig';

export default function ContactFicheLoader(props)
{
    const [selected, setSelected] = useState(null)

    useEffect(()=>{
        setSelected(null)
        getData()
    },[props.id])

    const getData = async () => {
        var res = await ApiService.get("/contact/id/" + props.id)
        console.log(res)

        if (res.success) {
            setSelected(res.data)
            await unNew(res.data)
        } else {
            console.log("CONTACT INTROUVABLE")
        }
    }

    const unNew=async (_selected)=>{
        if (_selected.new) {
            await ApiService.get("/contact/unnew/" + _selected.id)
            await getData()
        }
    }

    if(!selected){
        return(
            <div style={{width:"100%"}}>
                <MobHeader hasGoBack/>
                <div style={{height:300,display:"flex",justifyContent:"center",alignItems:'center'}}>
                    <MobSpin spinning={true}/>
                </div>
            </div>
        )
    }

    console.log("selected",selected)

    return(
        <ContactFiche selected={selected} refresh={()=>getData()} embedParams={props.embedParams || null}/>
    )
}



export function ContactFiche({selected,refresh,embedParams})
{
    const modalEdit=useRef(null)
    const [tabIndex, setTabIndex] = useState(0)
    const swiperPoint=useRef(null)

    const checkedForfait=checkForfait(["CRM", "COM", "FULL"])
    const [allowEdit, setAllowEdit] = useState(checkedForfait);
    useEffect(()=>{
        if(allowEdit !==checkedForfait){
            setAllowEdit(checkedForfait)
        }
    },[checkedForfait])

    const onDelete=async (id, type = "document")=>{
        if (!checkPermissions(["contact.edit"]) || !checkForfait(["CRM", "COM", "FULL"])) {
            notification.error({
                message: <IntlMessage id="access.error"/>
            })
            return false
        }

        await ApiService.post("/contact/" + type + "/delete/" + id + "/" + selected.id)
        await refresh()

        notification.success({
            message: <IntlMessage id="success.delete"/>
        })
    }

    const onUnarchiveContact=async ()=>{
        if (!checkPermissions(["contact.edit"]) || !checkForfait(["CRM", "COM", "FULL"])) {
            notification.error({
                message: <IntlMessage id="access.error"/>
            })
            return false
        }

        await ApiService.post("/contact/unarchive/" + selected.id)
        await refresh()

        notification.success({
            message: <IntlMessage id="success.delete"/>
        })
    }

    selected.__refreshData=refresh
    selected.__onDelete=onDelete
    selected.__onUnarchiveContact=onUnarchiveContact
    selected.__allowEdit=allowEdit


    let  tabItems=[t`Principales`,t`Secondaires`,t`Relations`,t`Shlihout`,t`Interactions`]

    return(
        <div ref={ref=>swiperPoint.current=ref}>

            {!embedParams ?(
                <MobHeader hasGoBack right={(
                    <div style={{width:"100%",display: "flex", alignItems: "center",justifyContent:"flex-end",gap:10}}>
                        <MobEditButton bordered onClick={()=>{
                            modalEdit.current.show(selected)
                        }}/>
                    </div>
                )}/>
            ):(
                <div style={{display:"flex",justifyContent:"flex-end",marginBottom:10}}>
                    <MobEditButton bordered onClick={()=>{
                        modalEdit.current.show(selected)
                    }}/>
                </div>
            )}

            <div style={{display:"flex",flexDirection:"column",gap:10}}>
                <div>
                    <ContactMainCard selected={selected} embedParams={embedParams}/>
                </div>

                {!allowEdit &&(
                    <div style={{minHeight:300,marginTop:20}}>
                        <ContactTabMain selected={selected}/>
                    </div>
                )}

                {allowEdit &&(
                    <>
                        <MobTabs index={tabIndex} onChange={setTabIndex} options={tabItems}/>

                        <div>
                            <SwipeableViews index={tabIndex} onChangeIndex={(index)=>{
                                setTabIndex(index)

                                setTimeout(() => {
                                    const scrollThreshold = 500;
                                    if (window.scrollY > scrollThreshold) {
                                        swiperPoint.current.scrollIntoView({
                                            behavior: 'smooth',
                                            block: 'start'
                                        });
                                    }
                                }, 200);

                            }}>
                                <div key={"ContactTabMain"} style={{minHeight:300}}>
                                    <ContactTabMain selected={selected}/>
                                </div>
                                <div key={"ContactTabSecondary"} style={{minHeight:300}}>
                                    <ContactTabSecondary selected={selected}/>
                                </div>
                                <div key={"ContactTabRelations"} style={{minHeight:300}}>
                                    <ContactTabRelations selected={selected}/>
                                </div>

                                <div key={'Shlihout'} style={{ minHeight: 300 }}>
                                    <ChlihoutForm selected={selected} />
                                </div>

                                <div key={'ContactTabInteractions'} style={{ minHeight: 300 }}>
                                <ContactTabInteractions selected={selected}/>
                                </div>
                            </SwipeableViews>
                        </div>
                    </>
                )}


            </div>

            <ModalEdit getRef={(ref) => modalEdit.current = ref} onFinish={(data, open) => {
                if (open) {
                    //this.modalContact.show(data.id)
                }
                selected.__refreshData()
            }}/>
        </div>
    )
}
